'use client'
import Link from 'next/link'
import React from 'react'
import { AdvancedButton } from '@/app/components/atoms/AdvancedButton'
import { resolveHref } from '~/app/lib/sanity.links'
import { useLenis } from '@/app/utils/lenis'
import { ButtonProps } from '~/app/types/ButtonProps'

const Button = ({ link, style, size, children, ...props }: ButtonProps) => {
  const lenis = useLenis() // eslint-disable-line

  return (
    <AdvancedButton
      {...props}
      size={size || 'default'}
      asChild
      variant={style || 'default'}
    >
      <Link
        onClick={(e) => {
          if (link.anchor && lenis) {
            e.preventDefault()
            lenis.scrollTo(link?.internalLink?._type, link.url)
          }
          onclick ? e : null
        }}
        {...(link?.blank && { rel: 'noopener noreferrer' })}
        href={
          link?.email
            ? `mailto:${link.email}`
            : link?.internalLink?._type
            ? resolveHref(link.internalLink._type, link.internalUrl) +
              (link?.anchor ? link.anchor : '')
            : link?.url + (link?.anchor ? link.anchor : '')
          }
        target={link?.blank ? '_blank' : '_self'}
        title={link?.label}
        aria-label={link?.label} >
        {children}  
      </Link>
    </AdvancedButton>
  )
}

export default Button
